import type { Component } from 'vue'
import { PhArrowLeft, PhEnvelopeSimple } from '@phosphor-icons/vue'
import i18n from '@/i18n'

export interface EmailSettingsNavItemDef {
  id: string
  label: string
  icon: Component
}

export interface EmailSettingsNavGroupDef {
  label: string
  items: EmailSettingsNavItemDef[]
}

export const EMAIL_SETTINGS_BACK_ICON = PhArrowLeft

// Keep the route and sidebar driven by one list so more email-specific
// settings can be added without creating another editor-side inspector tab.
export const EMAIL_SETTINGS_NAV_GROUPS: EmailSettingsNavGroupDef[] = [
  {
    get label() { return i18n.global.t('email.settingsNav.groupLabel') },
    items: [
      { id: 'info', get label() { return i18n.global.t('email.settingsNav.infoLabel') }, icon: PhEnvelopeSimple },
    ],
  },
]

export const EMAIL_SETTINGS_SLUGS = EMAIL_SETTINGS_NAV_GROUPS.flatMap(group => (
  group.items.map(item => item.id)
))

export function isEmailSettingsSlug(id: string): boolean {
  return EMAIL_SETTINGS_SLUGS.includes(id)
}

export function findEmailSettingsItem(id: string): EmailSettingsNavItemDef | null {
  for (const group of EMAIL_SETTINGS_NAV_GROUPS) {
    const item = group.items.find(candidate => candidate.id === id)
    if (item) return item
  }
  return null
}

export function emailSettingsItemRoute(contentId: string, id: string): string {
  return id === 'info'
    ? `/email/${contentId}/settings/info`
    : `/email/${contentId}/settings/${id}`
}

export function emailEditorRoute(contentId: string): string {
  return `/email/${contentId}`
}
